var mobileMenu = (function(){

  var mobileMenuIcon = document.querySelector('.mobile-menu-toggle');
  var itemsWithChildren = document.querySelectorAll('#menu-main-menu-1 .menu-item-has-children > a');
  var backLink = document.querySelectorAll('.back-link');
  var subMenuLink = document.querySelector('.mobile-subnav #parent');

  var mobileMenuToggle = function() {
    mobileMenuIcon.addEventListener('click', function(e){
      e.preventDefault();
      document.querySelector('body').classList.toggle('menu-open');
    });
  };

  var subMenuToggle = function() {
    for (var i = 0; i < itemsWithChildren.length; ++i) {
      itemsWithChildren[i].addEventListener('click', function(e) {
        e.preventDefault();
        this.nextElementSibling.classList.add('open-panel');
      });
    }
  };

  var backLinkToggle = function() {
    for (var i = 0; i < backLink.length; ++i) {
      backLink[i].addEventListener('click', function(e) {
        e.preventDefault();
        this.parentElement.parentElement.classList.remove('open-panel');
      });
    }
  };

  if(subMenuLink){
    var subNavToggle = function() {
      subMenuLink.addEventListener('click', function(e){
        e.preventDefault();
        document.querySelector('body').classList.toggle('menu-open-sub');
      });
    };
  }
  

  return {
    mobileMenuToggle: mobileMenuToggle,
    subMenuToggle: subMenuToggle,
    backLinkToggle: backLinkToggle,
    subNavToggle: subNavToggle
  };
})();

mobileMenu.mobileMenuToggle();
mobileMenu.subMenuToggle();
mobileMenu.backLinkToggle();

var subMenuLink = document.querySelector('.mobile-subnav #parent');

if(subMenuLink){
  mobileMenu.subNavToggle();
}
